import React, { Component } from "react";

const SNIPPET_LENGTH = 420;

// Presentation only: the original evidence and support values remain untouched.
export default class RagEvidenceCard extends Component {
  state = { expanded: false };

  render() {
    const { evidence, title, document, onView, passageId, pageCount } = this.props;
    const text = typeof evidence.evidenceText === "string" ? evidence.evidenceText : "";
    const displayExcerpt = typeof evidence.displayExcerpt === "string" ? evidence.displayExcerpt.trim() : "";
    const relevanceExcerpt = typeof evidence.relevanceExcerpt === "string" ? evidence.relevanceExcerpt.trim() : "";
    const excerpt = displayExcerpt || relevanceExcerpt;
    const pages = Array.isArray(evidence.sourcePageNumbers)
      ? [...new Set(evidence.sourcePageNumbers.filter(page => Number.isInteger(page) && page > 0))] : [];
    // Where the passage's own page is not known, the server may send the first and last page of the stored passage it was
    // read from (pageRange). Shown as a range, never as the quote's page; the viewer opens the first page of it.
    const range = pages.length === 0 && Array.isArray(evidence.pageRange) && evidence.pageRange.length === 2 &&
      evidence.pageRange.every(page => Number.isInteger(page) && page > 0) && evidence.pageRange[0] <= evidence.pageRange[1]
      ? evidence.pageRange : null;
    const openAt = pages.length > 0 ? Math.min(...pages) : range ? range[0] : null;
    const compactText = text.replace(/\s+/g, " ").trim();
    const isLong = compactText.length > SNIPPET_LENGTH || text.length > SNIPPET_LENGTH;
    const { expanded } = this.state;
    const snippet = compactText.length > SNIPPET_LENGTH
      ? compactText.slice(0, SNIPPET_LENGTH).trimEnd() + "…"
      : compactText;
    const collapsedText = excerpt || snippet;
    const canExpand = excerpt ? Boolean(text.trim()) && text.trim() !== excerpt : isLong;

    return (
      <article className="chat-search-evidence-card">
        <div className="chat-search-evidence-header">
          <div className="chat-search-evidence-document">
            <h4>{title}</h4>
            {document && (document.repositoryName || document.templateName) &&
              <p className="chat-search-evidence-repository">{document.repositoryName || document.templateName}</p>}
            {pages.length > 0 && (
              <p className="chat-search-evidence-pages">
                {pages.length === 1 ? "Page " : "Pages "}{pages.join(", ")}
              </p>
            )}
            {range && (
              <p className="chat-search-evidence-pages">
                {range[0] === range[1] ? "Page " + range[0] : "Pages " + range[0] + "–" + range[1] + " (the passage is on one of these pages)"}
              </p>
            )}
          </div>
        </div>
        <p id={passageId} className={"chat-search-evidence-passage" +
          (expanded ? " chat-search-evidence-passage-expanded" : "")}
          tabIndex={expanded ? 0 : undefined}>
          {(expanded ? text : collapsedText) || "No passage text is available."}
        </p>
        <div className="chat-search-evidence-actions">
          {document && (
            <button type="button" className="chat-search-ai-view-button"
              onClick={() => (openAt === null ? onView(document)
                // With the OCR page count the server read, so the viewer opens the page only where the image has as many pages.
                : Number.isInteger(pageCount) && pageCount > 0 ? onView(document, openAt, pageCount) : onView(document, openAt))}>View document</button>
          )}
          {canExpand && (
            <button type="button" className="chat-search-ai-action"
              aria-expanded={expanded} aria-controls={passageId}
              onClick={() => this.setState({ expanded: !expanded })}>
              {expanded ? "Show less" : "Show more"}
            </button>
          )}
        </div>
      </article>
    );
  }
}
